import { useState } from 'react';
import type { SignInFlowError } from '../../hooks/classify-auth-error';
import { AuthErrorMessage } from './AuthErrorMessage';
import { TOTP_CODE_LENGTH, TotpCodeInput } from './TotpCodeInput';

export interface TotpCodeFormProps {
  submitting: boolean;
  error: SignInFlowError | null;
  onSubmit: (code: string) => void;
  onRestart: () => void;
}

/**
 * サインイン時の認証アプリのコード入力
 */
export function TotpCodeForm({ submitting, error, onSubmit, onRestart }: TotpCodeFormProps) {
  const [code, setCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(code);
    // 誤りのときは新しいコードを入れ直してもらう
    setCode('');
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <AuthErrorMessage error={error} />
      <p className="text-sm text-muted-foreground">
        認証アプリに表示されている 6 桁のコードを入力してください。
      </p>
      <TotpCodeInput value={code} onChange={setCode} />
      <button
        type="submit"
        disabled={submitting || code.length !== TOTP_CODE_LENGTH}
        className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {submitting ? '確認中...' : '確認'}
      </button>
      <div className="space-y-2 text-center">
        <button
          type="button"
          onClick={onRestart}
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          サインインに戻る
        </button>
        <p className="text-xs text-muted-foreground">
          認証アプリを使えなくなった場合は、管理者に MFA のリセットを依頼してください。
        </p>
      </div>
    </form>
  );
}
